var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('report.witness.role'),
      "items": _vm.witnessRolesItems,
      "data-test-witness-role": "",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.$t("report.witness.roles.".concat(item))) + " ")];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$t("report.witness.roles.".concat(item))) + " ")];
      }
    }]),
    model: {
      value: _vm.value.role,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "role", $$v);
      },
      expression: "value.role"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "rules": _vm.required,
      "required": true,
      "label": _vm.$t('report.witness.firstName') + ' *',
      "data-test-witness-first-name": ""
    },
    model: {
      value: _vm.value.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "firstName", $$v);
      },
      expression: "value.firstName"
    }
  }), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "rules": _vm.required,
      "required": true,
      "label": _vm.$t('report.witness.lastName') + ' *',
      "data-test-witness-last-name": ""
    },
    model: {
      value: _vm.value.lastName,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "lastName", $$v);
      },
      expression: "value.lastName"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('report.witness.numberplate'),
      "data-test-witness-numberplate": ""
    },
    model: {
      value: _vm.value.numberplate,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "numberplate", $$v);
      },
      expression: "value.numberplate"
    }
  })], 1)], 1), _c('v-subheader', [_vm._v(_vm._s(_vm.$t("common.nouns.contact")))]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "rules": _vm.phoneRule,
      "label": _vm.$t('report.witness.phone'),
      "data-test-witness-phone": ""
    },
    model: {
      value: _vm.value.contact.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.value.contact, "phone", $$v);
      },
      expression: "value.contact.phone"
    }
  }), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "rules": _vm.emailRules,
      "label": _vm.$t('report.witness.email'),
      "data-test-witness-mail": ""
    },
    model: {
      value: _vm.value.contact.email,
      callback: function callback($$v) {
        _vm.$set(_vm.value.contact, "email", $$v);
      },
      expression: "value.contact.email"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t("report.witness.insurance")
    },
    model: {
      value: _vm.isInsuranceKnown,
      callback: function callback($$v) {
        _vm.isInsuranceKnown = $$v;
      },
      expression: "isInsuranceKnown"
    }
  }), _vm.isInsuranceKnown && _vm.value.insurances ? _c('insurance-form', {
    attrs: {
      "types": _vm.insuranceTypes,
      "type": _vm.insuranceType
    },
    model: {
      value: _vm.value.insurances[0],
      callback: function callback($$v) {
        _vm.$set(_vm.value.insurances, 0, $$v);
      },
      expression: "value.insurances[0]"
    }
  }) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t("report.witness.isInjured")
    },
    model: {
      value: _vm.value.isInjured,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isInjured", $$v);
      },
      expression: "value.isInjured"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "label": _vm.$t("common.nouns.note")
    },
    model: {
      value: _vm.value.note,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "note", $$v);
      },
      expression: "value.note"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }